[
  {
    "id": "SR-M7-TAXI-V01",
    "module": "SpellingRegel",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-X-KLANK",
    "conceptId": "x_as_ks_sound",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["taxi", "taksi", "taksie", "taxie"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'taksi', maar schrijft 'taxi' met een 'x'. De letter 'x' klinkt als 'ks'. Dit is een leenwoord.",
    "distractorExplanations": {
      "1": "Je schrijft 'x', niet 'ks'. De 'x' vervangt de 'ks'-klank.",
      "2": "Geen '-ie' aan het eind. Het is 'taxi', niet 'taksie'.",
      "3": "Geen '-ie' aan het eind. Het is 'taxi', niet 'taxie'."
    }
  },
  {
    "id": "SR-M7-CHEF-V01",
    "module": "SpellingRegel",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-CH-KLANK",
    "conceptId": "ch_as_sj_sound",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["chef", "sjef", "shef", "cefh"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'sjef', maar schrijft 'chef' met 'ch'. Dit is een Frans leenwoord. De 'ch' klinkt als 'sj' in Franse woorden.",
    "distractorExplanations": {
      "1": "Je schrijft 'ch', niet 'sj'. Franse leenwoorden behouden hun spelling.",
      "2": "Je schrijft 'ch', niet 'sh'. Dit is Frans, niet Engels.",
      "3": "De letters staan in de verkeerde volgorde."
    }
  },
  {
    "id": "SR-M7-THEE-V01",
    "module": "SpellingRegel",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-TH-KLANK",
    "conceptId": "th_silent_h",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["thee", "tee", "the", "te"],
    "correctAnswer": 0,
    "explanation": "'Thee' schrijf je met 'th'. De 'h' is stom (je hoort hem niet), maar hij hoort er wel bij. Dit is een weetwoord.",
    "distractorExplanations": {
      "1": "De 'h' ontbreekt. Het is 'thee' met 'th'.",
      "2": "Dit is de Engelse spelling. In het Nederlands schrijf je 'thee' met dubbele 'e'.",
      "3": "Te kort. Het is 'thee' met 'th' en dubbele 'e'."
    }
  },
  {
    "id": "SR-M7-ROUTE-V01",
    "module": "SpellingRegel",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-OU-KLANK",
    "conceptId": "french_ou_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["route", "roete", "routte", "ruute"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'roete', maar schrijft 'route' met 'ou'. Dit is een Frans leenwoord. De 'ou' klinkt als 'oe'.",
    "distractorExplanations": {
      "1": "Je schrijft 'ou', niet 'oe'. Franse leenwoorden behouden hun spelling.",
      "2": "Geen dubbele 't'. Het is rou-te.",
      "3": "Geen dubbele 'u'. Het is rou-te met 'ou'."
    }
  },
  {
    "id": "SR-M7-COMPUTER-V01",
    "module": "SpellingRegel",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-C-ALS-K",
    "conceptId": "c_as_k_sound",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["computer", "komputer", "computter", "conputer"],
    "correctAnswer": 0,
    "explanation": "'Computer' schrijf je met een 'c'. Het is een Engels leenwoord. De 'c' klinkt als 'k' (voor 'o').",
    "distractorExplanations": {
      "1": "Je hoort 'k', maar schrijft 'c'. Leenwoorden behouden hun spelling.",
      "2": "Geen dubbele 't'. Het is com-pu-ter.",
      "3": "Het is 'com-' met een 'm', niet 'con-' met een 'n'."
    }
  }
]